import Service from "../../Services";

const DesignWorldCalendar = {
  namespaced : true,
  state : {
    form : {
      name_th : '',
      name_en : '',
      description_th : '',
      description_en : '',
      location : '',
      event_date : '',
      end_event_date : '',
      image : '',
      image_show : '',
    }
  },
  mutations : {
    GET_FORM:(state,res)=>{
      state.form = res;
    },
    CLEAR_FORM_DATA :(state)=>{
      state.form = {
        name_th : '',
        name_en : '',
        description_th : '',
        description_en : '',
        location : '',
        event_date : '',
        end_event_date : '',
        image : '',
        image_show : '',
      }
    }
  },
  actions : {
    getDesignWorldCalendar({commit},{page,search,sort_date,sort_column}){
      return Service.DesignWorldCalendarAPI.getDesignWorldCalendar(page,search,sort_date, sort_column);
    },
    showDesignWorldCalendar({commit},id){
      return Service.DesignWorldCalendarAPI.showDesignWorldCalendar(id);
    },
    saveDesignWorldCalendar({commit},{id,data}){
      if(id){
        return Service.DesignWorldCalendarAPI.updateDesignWorldCalendar(id,data);
      }else{
        return Service.DesignWorldCalendarAPI.createDesignWorldCalendar(data);
      }
    },
    deleteDesignWorldCalendar({commit},id){
      return Service.DesignWorldCalendarAPI.deleteDesignWorldCalendar(id);
    },
    setFormDesignWorldCalendar({commit},res){
      commit('GET_FORM',res);
    },
    clearFormData({commit}){
      commit('CLEAR_FORM_DATA');
    }
  },
}
export default DesignWorldCalendar
